import { defineComponent as _defineComponent } from 'vue'
import { getHostname } from '@@/bits/url'
import type { ImageSearchResult } from '@@/bits/web_search'
import { SearchFilters } from '@@/bits/web_search'
import ImageThumbnail from '@@/library/v4/components/ImageThumbnail.vue'
import { fetchJson } from '@padlet/fetch'
import { computed, nextTick, onMounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPickerSearchResultsImage',
  props: {
    results: null,
    filter: null
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'select', url: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  results: ImageSearchResult[]
  filter: SearchFilters
};





const LOADING_IMAGES_BG_COLOR = ['red', 'blue', 'green', 'yellow', 'purple', 'pink', 'cyan', 'orange']

const container = ref<HTMLUListElement>()
const imageWrappers = ref<HTMLLIElement[]>()

const imageWidth = ref(0)

const erroredThumbnailUrls = ref(new Set())

const validResults = computed(() =>
  props.results.filter((result) => !erroredThumbnailUrls.value.has(result.thumbnail_url)),
)
const isShowingAiImages = computed<boolean>(() => props.filter === SearchFilters.AiImages)

const handleResultsUpdate = async (): Promise<void> => {
  await nextTick()
  imageWidth.value = imageWrappers.value && imageWrappers.value[0] ? imageWrappers.value[0].clientWidth : 0
}

const selectWithBeacon = (url: string, beaconLink: string): void => {
  if (beaconLink) {
    fetchJson(beaconLink, { cors: true })
  }
  emit('select', url)
}

const providerName = (result: ImageSearchResult): string => {
  if (result.provider_name) return result.provider_name
  return getHostname(result.url)
}

const handleImageError = (erroredUrl) => {
  erroredThumbnailUrls.value = new Set([...erroredThumbnailUrls.value, erroredUrl])
}

watch(() => props.results, handleResultsUpdate)

onMounted((): void => {
  imageWidth.value = (container.value?.clientWidth ?? 0) / 3 - 12
  // After the components are auto-layouted, we assigned the fixed imageWidth so that
  // Beethoven-Vivaldi can load the most size-optimal image
  handleResultsUpdate()
})

return { __sfc: true,props, emit, LOADING_IMAGES_BG_COLOR, container, imageWrappers, imageWidth, erroredThumbnailUrls, validResults, isShowingAiImages, handleResultsUpdate, selectWithBeacon, providerName, handleImageError, ImageThumbnail }
}

})